import Vue from 'vue';
import Vuex from 'vuex';

import urlsAPI from '../../config/urlsAPI';
import handlerError from '../../utils/errors';
import { axiosInstance } from '../../main';

Vue.use(Vuex);

export const AnalyzerStoreModel = {
  name: '',
  series: '',
  expireAt: new Date().toISOString(),
};

export default {
  namespaced: true,
  state: {
    analyzer: { ...AnalyzerStoreModel },
    analyzers: [],
  },
  mutations: {
    updateOne(state, analyzer) {
      state.analyzer = analyzer;
    },
    updateAll(state, analyzers) {
      state.analyzers = analyzers;
    },
    add(state, analyzer) {
      state.analyzers.push(analyzer);
      state.analyzer = { ...AnalyzerStoreModel };
    },
    modify(state, analyzer) {
      state.analyzers = state.analyzers.map((value) => (analyzer.id === value.id ? analyzer : value));
      state.analyzer = { ...AnalyzerStoreModel };
    },
    delete(state, id) {
      state.analyzers = state.analyzers.filter((analyzer) => analyzer.id !== id);
    },
  },
  actions: {

    async getAnalyzer({ commit }, id) {
      axiosInstance.get(urlsAPI.analyzersURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateOne', response.data);
          }
        })
        .catch(handlerError);
    },

    async getAnalyzers({ commit }) {
      axiosInstance.get(urlsAPI.analyzersURL)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateAll', response.data);
          }
        })
        .catch(handlerError);
    },

    async create({ commit, state }) {
      return axiosInstance.post(urlsAPI.analyzersURL, state.analyzer)
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          commit('add', response.data);
          return response.data;
        })
        .catch(handlerError);
    },

    async update({ commit, state }, id) {
      return axiosInstance.put(urlsAPI.analyzersURL + id, state.analyzer)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('modify', response.data);
          }
        })
        .catch(handlerError);
    },

    async delete({ commit }, id) {
      return axiosInstance.delete(urlsAPI.analyzersURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('delete', id);
          }
        })
        .catch(handlerError);
    },

  },
};
